import { useEffect, useState } from 'react';
import { Container, Form } from 'react-bootstrap';
import { FaLaugh } from 'react-icons/fa';
import Banner from '../../../components/banner/Banner';
import { PageMeta } from '../../../components/meta/PageMeta';
import { useGetAllLocationsSimpleQuery } from '../../../services/endpoints/places/location';
import { useGetAllTeamProfilesQuery } from '../../../services/endpoints/website/teamProfile';
import { TeamProfile } from '../../../types/website.types';

const TeamProfileCard = ({ profile }: { profile: TeamProfile }) => (
  <div className="div-masonry-content">
    <img
      src={`${profile.s3_base_url}/${profile.image_file_name}`}
      alt={profile.name}
      className="image-bio green"
      style={{ maxWidth: 120 }}
    />
    <div className="subheader">{profile.title}</div>
    <h3>{profile.name}</h3>
    <div className="div-quotation">
      <div className="text-bio" dangerouslySetInnerHTML={{ __html: profile.description ?? '' }} />
      {profile.quote_type === 'joke' ? (
        <>
          <div className="d-flex align-items-center">
            <div className="text-fa pun"><FaLaugh size={16} /></div>
            <div className="pun"><em>Favorite Food Joke</em></div>
          </div>
          <div className="small">{profile.quote}</div>
        </>
      ) : profile.quote ? (
        <blockquote className="block-quote bio"><em>{profile.quote}</em></blockquote>
      ) : null}
    </div>
  </div>
);

export const OurCrewPage = () => {
  const { data: locationsData } = useGetAllLocationsSimpleQuery();
  const [selectedLocationId, setSelectedLocationId] = useState<number | null>(null);
  const [locationProfiles, setLocationProfiles] = useState<Record<number, TeamProfile[]>>({});

  const locations = locationsData ?? [];

  const { data: hqData } = useGetAllTeamProfilesQuery({
    data: {
      entries: 1000,
      filterBy: [{ field: 'is_hq', operator: 'equals', value: 1 }],
      orderBy: { field: 'position', order: 'asc' }
    }
  });

  const { data: allLocationData } = useGetAllTeamProfilesQuery({
    data: {
      entries: 1000,
      filterBy: [{ field: 'is_hq', operator: 'equals', value: 0 }],
      orderBy: { field: 'position', order: 'asc' }
    }
  });

  useEffect(() => {
    if (allLocationData?.results) {
      const grouped: Record<number, TeamProfile[]> = {};
      allLocationData.results.forEach((p: TeamProfile) => {
        if (p.location_id) {
          if (!grouped[p.location_id]) grouped[p.location_id] = [];
          grouped[p.location_id].push(p);
        }
      });
      setLocationProfiles(grouped);
    }
  }, [allLocationData]);

  const selectedLocation = locations.find(l => l.id === selectedLocationId);
  const profiles = selectedLocationId === null
    ? hqData?.results ?? []
    : locationProfiles[selectedLocationId] ?? [];
  const heading = selectedLocationId === null ? 'HQ Team' : `${selectedLocation?.title} Team`;

  return (
    <>
      <PageMeta title="Our Crew" description="Meet the Sticky Fingers Cooking team." />
      <Banner title="Our Crew" pageTitle="Our Crew" mainPage="Home" hideBreadcrumb />
      <Container className="py-5">
        <div className="d-flex align-items-center gap-3 mb-4 flex-wrap">
          <h2 className="text-info fw-bold mb-0">{heading}</h2>
          <Form.Select
            style={{ maxWidth: 280 }}
            value={selectedLocationId ?? ''}
            onChange={(e) => setSelectedLocationId(e.target.value === '' ? null : Number(e.target.value))}
          >
            <option value="">HQ Team</option>
            {locations.map(loc => (
              <option key={loc.id} value={loc.id}>{loc.title} Team</option>
            ))}
          </Form.Select>
        </div>
        <div className="div-masonry-2-column">
          {profiles.map((profile: TeamProfile) => (
            <TeamProfileCard key={profile.id} profile={profile} />
          ))}
        </div>
      </Container>
    </>
  );
};
